module.exports = __webpack_public_path__ + "static/media/IMG_7230.d91e7c44.PNG";